import { useState,useEffect } from 'react'
import Header from '../Header'
import Footer from '../Footer'
import FilterProveedor from '../Filtros/FilterProveedor'

const PageProvider = ({user,removeProduct,subTotal,miproductos,expressActive,changeHasExpress,changeMethodShopping,methodShopping,loadMenu,loadTransversal,transversal,menus,myLazyLoad,myListCart,handleMiproductos,handleSubTotal}) =>{
	const [showlist,setShowlist] = useState(0)
	const [team, setTeam ] = useState([])

	const [landing,setLanding] = useState([])

    const handleTeam = (data) =>{
        setTeam(data)
    }

    const editItem = (data) =>{
        window.location.href = "/provider/"+data;
    }

  const list_documentos = 
  [
    {id:1,name:"Ruc"},
    {id:2,name:"Pasaporte"},
    {id:3,name:"Dni"}
  ]


	const getInfoDocument= (idbank) => {
		
		const info = list_documentos.filter(function(item) {
		    return item.id==idbank
		})

		return (info.length === 1) ? info[0] : [];
	}



    const confirmdeleteItem = (data) =>{
        window.Swal.fire({
          title: 'Estas Seguro de eliminar?',
          icon: 'warning',
          showCancelButton: true,
          cancelButtonColor: "#666",
          confirmButtonColor: "#13a538",
          confirmButtonText: 'Si',
          cancelButtonText: "No"
        }).then((result) => {
          if (result.isConfirmed) {
            deleteItem(data)
          }
        })        
    }    
    
    const deleteItem = async(vdata) =>{
      let modaLoading;
      modaLoading = 
        window.Swal.fire({
          imageUrl: window.path_service+'/images/loading.png',
          title: 'Cargando datos...',
          showConfirmButton: false,
          customClass: 'ms-loading-modal',
            allowOutsideClick: false
        }); 
        

        if ( ![undefined,"undefined",""].includes(localStorage.token_authlead) ) {
              var myHeaders = new Headers();
              myHeaders.append("Authorization", "Bearer "+ localStorage.token_authlead );

          let apiRequest = window.path_service+"/products/delete";
          const response = await fetch(apiRequest,{method:'POST',body:  JSON.stringify({id:vdata}) , headers: myHeaders})
          const data = await response.json()


          if ( data.hasOwnProperty("status") && data.status ) {
            window.Swal.fire({
                    icon: 'success',
                    title: data.message,
                    showConfirmButton: false,
                    timer: 3500
                });                   
            setShowlist(showlist+1)
          }else{
              window.Swal.fire({
                    icon: 'error',
                    title: data.message !== "" ? data.message : "Surgio un error inesperado, intentalo nuevamente",
                    showConfirmButton: false,
                    timer: 2500
              });           
          }
        }
        
        modaLoading.close();        
    } 

	useEffect(() => {

			if ( 
				["",undefined,"undefined"].includes( localStorage.token_authlead )
				) {
				window.location.href = "/login";
			}
	}, []);

    return (
	    <div className="page-content-detailt">

       <FilterProveedor showlist ={showlist} handleTeam={handleTeam}/>

        <div className="list-products">
          <h5>Mis Proveedores</h5>
          <table className="table" id="myFilters">
             <thead>
					      <tr>
					         <th className="ms-item-1">
					         </th>
					         <th className="ms-item-11">RUC</th>
					         <th className="ms-item-2">TIPO DOCUMENTO</th>
					         <th className="ms-item-2">REGISTRADO</th>
					         <th className="ms-item-7">MODIFICADO</th>
					         <th className="ms-item-9">Editar</th>
					         <th className="ms-item-10">Eliminar</th>
					      </tr>

             </thead>
             <tbody className="js-list-team">
					{team.map(
						person => 
                <tr id={"item_"+person.id}>
	                <td className="filterMore ms-item-1 ico-my-buildings ms-icon no-border -chk-active">
	                {
	                	person.role ==="superadmin" ?
	                		<a className="ms-sc-title">{person.name}</a>
	                	:
	                		<a onClick={() => editItem(person.id)} className="ms-sc-title">{person.name}</a>
	                }
					</td>
					<td className="ms-item-11 ms-full"><span>RUC</span>{person.numero_documento}</td>
					<td className="ms-item-5 ms-md"><span>FECHA NACIMIENTO</span>{getInfoDocument(person.id_tipo_documento).name}</td>
 					<td className="ms-item-2 ms-md"><span>REGISTRADO</span>{person.created_on}</td>
					<td className="ms-item-7 ms-md"><span>MODIFICADO</span>{person.modified_on}</td>
					<td className="ms-item-9"><span>Edit</span>
					
					{
						person.role ==="superadmin" ?
						null
						:
						<a onClick={() => editItem(person.id)} title="Edit" className="ms-edit-mx"><span>Edit</span></a>
					}					
					</td>
					<td className="ms-item-10 no-border"><span>Delete</span>
					{
						person.role ==="superadmin" ?
							null
						:
							<a href="#" onClick={() => confirmdeleteItem(person.id)} className="ms-delete-mx flex-filter-confirm-delete" data-toggle="modal" data-target="#modal-delete"><span>Delete</span></a>
					}
					</td>
				</tr>

					)}
             </tbody>
          </table>
        </div>
        

	    </div>
    )
}

export default PageProvider;